import React, {FC} from "react";
import {Button} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";
import RibbonBadgeEZB from "../../../views/RibbonBadgeEZB/RibbonBadgeEZB";
import MollieBadge from "../../../views/MollieBadge/MollieBadge";

type ModifyBookingsModalTitleProps = {
    courseNumber?: string | null;
    allowMolliePayment?: boolean;
    // Phase 3 (P3-7): unterscheidet im Badge-Tooltip Pflicht vs. optional.
    // undefined ⇒ Pflicht-Anzeige (kompatibel zu Callern ohne das Flag).
    mollieOptional?: boolean;
    onInfoClick: () => void;
};

const ModifyBookingsModalTitle: FC<ModifyBookingsModalTitleProps> = ({courseNumber, allowMolliePayment, mollieOptional, onInfoClick}) => {
    const title = courseNumber ? `Buchungen anpassen (${courseNumber})` : "Buchungen anpassen";
    const mollieBadgeTitle = mollieOptional === true ? "Online-Zahlung (zusätzlich)" : "Online-Zahlung (verpflichtend)";

    return (
        <RibbonBadgeEZB style={{marginLeft: -24, marginTop: -32}}>
            <div style={{display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 5}}>
                <div>{title}</div>
                {allowMolliePayment && <MollieBadge title={mollieBadgeTitle} />}
                <Button type="link" onClick={onInfoClick} icon={<InfoCircleOutlined style={{fontSize: 18, marginBottom: -3}} />} />
            </div>
        </RibbonBadgeEZB>
    );
};

export default ModifyBookingsModalTitle;
